//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import fileUploader from '../../views/common-components/file-uploader.vue';

export default {
    name: 'contentInfo1',
    components: {
        fileUploader
    },
    data() {
        // const vm = this;
        return {
            loading: false,
            contentId: 0,
            content: {},
            contentType: 'ContentImage',
            businessType: 'content.remarks',
            giContent: {},
            saving: false
        };
    },
    methods: {
        getContent() {
            this.loading = true;
            this.content = {};
            abp.ajax
                .get('/api/services/app/Content/GetContentById?id=' + this.contentId)
                .then(resp => {
                    console.log(resp.data.result);
                    this.content = resp.data.result;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getGraphicInformation(businessType) {
            this.loading = true;
            abp.ajax.get('/api/services/app/GraphicInformation/GetGraphicInformationByBusiness?businessId=' +
                this.contentId + '&businessType=' + this.businessType)
                .then((
                    resp) => {
                    if (resp.data.result != null) {
                        this.giContent = resp.data.result;
                        console.log(this.giContent);
                    }
                    console.log(resp);
                }).finally(() => {
                this.loading = false;
            });
        },
        editContent(content) {
            // var id = content.id;
            // var nodeName = this.nodeName;
            // var nodeId = content.nodeId;
            this.$router.push('/contentEdit/' + this.contentId);
        },
        changStatus(id, status) {
            let str = '';
            if (status === 0) {
                str = '确认下架？';
            } else {
                str = '确认发布？';
            }
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: str,
                onOk: () => {

                    this.saving = true;
                    this.content = {};
                    abp.ajax.post('/api/services/app/Content/ChangeStatus', {
                        id: id,
                        status: status
                    }).then(() => {
                        this.getContent();
                        this.getGraphicInformation(this.businessType);
                    }).finally(() => {
                        this.saving = false;
                    });

                }
            });
        },
        delContent() {
            // this.saving = true;

            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除' + this.content.title + '吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {


                    this.$store.dispatch({
                        type: 'content/delContent',
                        id: this.contentId
                    }).then(() => {
                        this.$Notice.success({
                            duration: 3,
                            title: this.content.title + '已删除'
                        });
                        // this.getNodeList();
                        // this.getPage();

                    }, (error) => {
                        this.$Modal.error({
                            title: '删除提示'
                        });
                        this.$Message.destroy();
                    }).finally(() => {
                        // this.saving = false;
                    });

                }

            });
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    created() {
        this.contentId = parseInt(this.$route.params.id || 0);
        if (this.contentId != 0) {
            this.getContent();
            this.getGraphicInformation(this.businessType);
        }
    },
    computed: {},
    mounted() {
    },
    watch: {
        // $route: {
        //     handler: function (val, oldVal) {
        //         this.contentId = parseInt(this.$route.params.id || 0);
        //         if (this.contentId != 0) {
        //             this.getContent();
        //             this.getGraphicInformation(this.businessType);
        //         }
        //     },
        //     deep: true
        // }
    }
};
